module.exports = __webpack_public_path__ + "static/media/team_7.71ee22d7.png";